import { render } from "./Tooltip.vue?vue&type=template&id=028aefcf&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=028aefcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028aefcf"]])

export default __exports__